import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f040f6e6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=f040f6e6&prod&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=f040f6e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f040f6e6",
  null
  
)

export default component.exports